<div class="pt-[125px] md:pt-[145px] lg:pt-[185px] xl:pt-[195px] text-left">
    <div class="container 2xl:max-w-[1320px] mx-auto px-[12px] relative z-[1]">
        <pre>
Its'Me UserInfo : 
<code>
{{userinfo()}}
</code>
</pre>
    </div>
</div>